import { useCallback, useMemo, useState } from "react"
import { Button, Snackbar, IconButton } from "@mui/material"
import { Link as LinkIcon, Close as CloseIcon } from "@mui/icons-material"

function CopyLinkButton() {
    const [snackbarOpen, setSnackbarOpen] = useState(false)

    const handleCopy = useCallback(() => {
        navigator.clipboard.writeText(window.location.href)
        setSnackbarOpen(true)
    }, [])

    const handleClose = useCallback((event, reason) => {
        if (reason === 'clickaway') return
        setSnackbarOpen(false)
    }, [])

    const action = useMemo(() => (
        <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleClose}
        >
            <CloseIcon fontSize="small" />
        </IconButton>
    ), [handleClose])

    return (
        <>
            <Button
                variant="iconAction"
                color="inherit"
                onClick={handleCopy}
            >
                <LinkIcon fontSize="small" />
            </Button>

            <Snackbar
                open={snackbarOpen}
                autoHideDuration={3000}
                onClose={handleClose}
                message="Link copied to clipboard"
                action={action}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            />
        </>
    )
}

export default CopyLinkButton
